import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TableRow, TableCell, Box, Typography, Link, IconButton, useTheme } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const SortableBannerRow = ({ banner, cellStyle, textStyle, disabled = false }) => {
  const theme = useTheme();
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: banner.id,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <TableRow ref={setNodeRef} style={style} hover>
      <TableCell sx={{ ...cellStyle, p: 0 }}>
        <IconButton
          ref={setActivatorNodeRef}
          {...attributes}
          {...listeners}
          disabled={disabled}
          aria-label={`${banner.appConfig?.headline || banner.title} 순서 이동`}
          sx={{ minWidth: 44, minHeight: 44, cursor: 'grab', touchAction: 'none' }}
        >
          <DragIndicatorIcon sx={{ color: theme.palette.black[3] }} />
        </IconButton>
      </TableCell>
      <TableCell
        align="center"
        sx={{ ...cellStyle, minWidth: 224, width: 224, height: 144, p: 0, overflow: 'hidden' }}
      >
        <Box
          component="img"
          src={banner.appConfig?.imageUrl || banner.imageUrl}
          alt={banner.title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </TableCell>
      <TableCell sx={{ ...cellStyle, minWidth: 300, width: 300 }}>
        <Typography {...textStyle}>{banner.appConfig?.headline || banner.title}</Typography>
      </TableCell>
      <TableCell sx={cellStyle}>
        <Link
          href={banner.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textDecoration: 'none' }}
        >
          <Typography
            {...textStyle}
            sx={{
              maxWidth: 300,
              width: 300,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {banner.url}
          </Typography>
        </Link>
      </TableCell>
      <TableCell align="right">
        <Typography {...textStyle}>{banner.clickCount.toLocaleString()}</Typography>
      </TableCell>
    </TableRow>
  );
};

export default SortableBannerRow;
